import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoaderText from '../components/loader/LoaderText';
import { NAVIGATE_AUTH } from '../constant';
import RequireCompanyCode from '../providers/RequireCompanyCodeProvider';
import CompanySelection from '../pages/Auth/company-select';
import AuthLayout from '../layout/AuthLayout';
import ResetPasswordForm from '../pages/Auth/forgot-password/ResetPassword';
const AdminLayout = lazy(() => import('../layout/AdminLayout'));
const AuthRoute = lazy(() => import('./AuthRoute'));
const GuestRoute = lazy(() => import('./GuestRoute'));
const AdminRoute = lazy(() => import('./AdminRoute'));
const UserRoute = lazy(() => import('./UserRoute'));
const CommonDrawerComponent = lazy(() => import('../components/drawer'));


const AppRoute = () => {

    return (
        <>
            <Suspense fallback={<LoaderText />}>
                <Routes>
                    <Route path="/company-selection" element={<CompanySelection />} />
                    <Route path="/auth/reset-password" element={<AuthLayout><ResetPasswordForm /></AuthLayout>} />
                    <Route path="/:companyCode/*" element={
                        <RequireCompanyCode>
                            <Routes>
                                <Route path={`${NAVIGATE_AUTH.AUTH}/*`} element={<AuthRoute />}></Route>
                                <Route path={`${NAVIGATE_AUTH.LOGIN}`} element={<Navigate to={NAVIGATE_AUTH.LOGIN_PAGE} />}></Route>
                                <Route path={'*'} element={<AdminLayout>  <AdminRoute /> </AdminLayout>}></Route>
                                {/* <Route path={`${NAVIGATE_MODULE.USER}/*`} element={<UserRoute />}></Route> */}
                                {/* <Route path={`${NAVIGATE_MODULE.HOME}`}  element={<Navigate to={NAVIGATE_AUTH.LOGIN_PAGE} />}></Route> */}
                                {/* <Route path='*' element={<GuestRoute />}></Route> */}
                            </Routes>
                        </RequireCompanyCode>} />
                    <Route path="*" element={<Navigate to="/company-selection" replace />} />
                </Routes>
            </Suspense>
            <CommonDrawerComponent />
        </>
    )
}

export default AppRoute;